<div class="country-link-wrap">
  <a class="country-selector-link flag-se"
     aria-label="Cake it easy Swedish"
     [href]="urls.SE"
     [translate]="'footerLayout.availableIn.sweden'">
    Sweden
  </a>
</div>

<div class="country-link-wrap">
  <a class="country-selector-link flag-no"
     aria-label="Cake it easy Norway"
     [href]="urls.NO"
     [translate]="'footerLayout.availableIn.norway'">
    Norway
  </a>
</div>
